// University of Dayton's undergraduate majors (#2652). Read on 2026-10-01
// from the official 2026-2027 Undergraduate Catalog (catalog.udayton.edu):
// the College of Arts and Sciences and School of Business Administration
// "Academic Programs" pages, the School of Education and Health Sciences
// "Baccalaureate Programs" page, and the School of Engineering's department
// pages (reached from its Programs of Study page, which each group cites).
// Degrees are written as the catalog gives them: abbreviations where it uses
// them (B.A., B.S., B.F.A., B.M., BSHS, BSE...), the full degree name where
// it uses only that (Bachelor of Chemical Engineering, Bachelor of Science in
// Business Administration). Left out: programs the catalog marks "No new
// students will be admitted this academic year" (International Studies,
// Graphic Design, Photography, Early Childhood Leadership and Advocacy,
// Middle Childhood Education, Middle Childhood Education/Intervention
// Specialist, Pre-Kindergarten to Grade 5 Education), co-majors (taken with a
// primary major: Neuroscience, Aerospace, Artificial Intelligence, Bio-,
// Materials, Mechatronics and Semiconductor Manufacturing Engineering), the
// individually designed Interdisciplinary Studies degree, minors and
// certificates. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-dayton",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major open to new students in the University of Dayton's 2026-2027 Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. Co-majors, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "University of Dayton 2026-2027 Undergraduate Catalog, College of Arts and Sciences, Academic Programs",
                "url": "https://catalog.udayton.edu/undergraduate/collegeofartsandsciences/academicprograms/"
            },
            "majors": [
                {
                    "name": "Applied Mathematical Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Art Education",
                    "degree": "B.F.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Criminal Justice and Security Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Earth and Environmental Geosciences",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Biology",
                    "degree": "B.S."
                },
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Rights Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Music Therapy",
                    "degree": "B.M."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Predentistry",
                    "degree": "B.S."
                },
                {
                    "name": "Premedicine",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainability",
                    "degree": "B.A."
                },
                {
                    "name": "Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "Theatre, Dance and Performance Technology",
                    "degree": "B.A."
                },
                {
                    "name": "Theology and Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Business Administration",
            "source": {
                "label": "University of Dayton 2026-2027 Undergraduate Catalog, School of Business Administration, Academic Programs",
                "url": "https://catalog.udayton.edu/undergraduate/schoolofbusinessadministration/academicprograms/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Business Analytics",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Business Economics",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Cybersecurity Management",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Operations and Supply Chain Management",
                    "degree": "Bachelor of Science in Business Administration"
                }
            ]
        },
        {
            "name": "School of Education and Health Sciences",
            "source": {
                "label": "University of Dayton 2026-2027 Undergraduate Catalog, School of Education and Health Sciences, Baccalaureate Programs",
                "url": "https://catalog.udayton.edu/undergraduate/schoolofeducationandhealthsciences/baccalaureateprograms/"
            },
            "majors": [
                {
                    "name": "Adolescence to Young Adult Education",
                    "degree": "BSE"
                },
                {
                    "name": "Dietetics",
                    "degree": "BSHS"
                },
                {
                    "name": "Elementary and Middle Grades Education",
                    "degree": "BSE"
                },
                {
                    "name": "Health Science",
                    "degree": "BSHS"
                },
                {
                    "name": "Intervention Specialist (Special Education)",
                    "degree": "BSE"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Secondary Catholic Religion Education",
                    "degree": "BSE"
                },
                {
                    "name": "Sport Management",
                    "degree": "BSSW"
                },
                {
                    "name": "World Language Education (Multi-Age P-12)",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "University of Dayton 2026-2027 Undergraduate Catalog, School of Engineering, Programs of Study",
                "url": "https://catalog.udayton.edu/undergraduate/schoolofengineering/programsofstudy/"
            },
            "majors": [
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Chemical Engineering"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Civil Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science in Computer Engineering"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Electrical Engineering"
                },
                {
                    "name": "Electronic Engineering Technology",
                    "degree": "Bachelor of Science in Engineering Technology"
                },
                {
                    "name": "Industrial Engineering Technology",
                    "degree": "Bachelor of Science in Engineering Technology"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Mechanical Engineering"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "Bachelor of Science in Engineering Technology"
                },
                {
                    "name": "Physical Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Systems and Industrial Engineering",
                    "degree": "Bachelor of Science in Systems and Industrial Engineering"
                }
            ]
        }
    ]
};

export default majors;
